export default "__VITE_ASSET__3bdcc104__"